import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class CreateEventService {

  // Save Info Event
  private infoObservable = new BehaviorSubject<any>(null);
  public info = this.infoObservable.asObservable();

  // Capacity
  capacityObservable = new BehaviorSubject<any>(null);
  capacity = this.capacityObservable.asObservable();

  // Map Event
  mapObservable = new BehaviorSubject<any>(null);
  map = this.mapObservable.asObservable();

  private jsonMapObject = new BehaviorSubject<any>(null);
  public jsonMap = this.jsonMapObject.asObservable();

  // Event type
  private eventTypeObservable = new BehaviorSubject<'informative' | 'external' | 'normal' | null>(null);
  public eventType$ = this.eventTypeObservable.asObservable();

  patchEventType(type: 'informative' | 'external' | 'normal') {
    this.eventTypeObservable.next(type);
  }

  constructor(private http: HttpClient) { }

  // Comprueba que la URL sea un enlace real a un vídeo de YouTube (youtube.com/watch?v=...,
  // youtu.be/... o youtube.com/embed/...), no solo que "parezca" una URL. Vacío se considera
  // válido: el campo es opcional (ver create-event.component.html/router-create.component.ts,
  // que solo bloquean el guardado cuando HAY texto y no tiene este formato).
  isValidYoutubeUrl(url: string | null | undefined): boolean {
    const trimmed = (url || '').trim();
    if (!trimmed) return true;
    let parsed: URL;
    try {
      parsed = new URL(trimmed);
    } catch {
      return false;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
    const host = parsed.hostname.replace(/^www\./, '').replace(/^m\./, '');
    let videoId: string | null = null;
    if (host === 'youtu.be') {
      videoId = parsed.pathname.slice(1).split('/')[0];
    } else if (host === 'youtube.com' || host === 'music.youtube.com') {
      videoId = parsed.pathname.startsWith('/embed/')
        ? parsed.pathname.replace('/embed/', '').split('/')[0]
        : parsed.searchParams.get('v');
    } else {
      return false;
    }
    return !!videoId && /^[a-zA-Z0-9_-]{11}$/.test(videoId);
  }

  getInfoEvent() {
    return this.infoObservable.getValue();
  }

  setInfoDetail(payload: any) {
    this.infoObservable.next(payload);
  }

  getJsonMap() {
    return this.jsonMapObject.getValue();
  }

  setJsonMap(jsonMap: any) {
    this.jsonMapObject.next(jsonMap);
  }

  getCapacity() {
    return this.capacityObservable.getValue();
  }

  setCapacity(capacity: number) {
    this.capacityObservable.next(capacity);
  }

  getMapEvent() {
    return this.mapObservable.getValue();
  }

  setMapEvent(map: any) {
    this.mapObservable.next(map);
  }

  createEventBusiness(payload: any) {
    const url = `${AppSettings.API_URI_V2}/events`;
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      }), 
      catchError(err => { return throwError(() => err); })
    );
  }
}
